import styled from 'styled-components';
import { Flex, IFlexProps } from '../containers/Flex/Flex.component';
import { FC } from 'react';

/**
 * @deprecated
 */
export const HeaderSectionStyle = styled(Flex)`
  background: transparent;
  align-items: stretch;

  font-family: ${({ theme }) => theme.fonts.base};
  font-size: 15px;
  line-height: normal;
`;
/**
 * @deprecated
 */
export const HeaderSection: FC<IFlexProps> = props => <HeaderSectionStyle m={0} p={0} {...props} />;

HeaderSection.displayName = 'HeaderSection';
